<style lang="scss">
    @import "~@/assets/css/var";
    .my-drawer {
        .el-drawer {
            transition: width .15s ease-in-out;
        }

        .el-form-item__label{
            font-size: 12px;
        }

        .el-drawer__header {
            display: block;
            margin-bottom: 15px;
            font-size: 16px;
            background: #f2f2f2;
            line-height: 60px;
            padding: 0 20px;

            span {
                font-size: 16px;
                float: right;
            }

            i {
                font-size: 18px;
                padding-left: 10px;
                cursor: pointer;
            }

            .el-icon-full-screen {
                &:hover {
                    color: $main;
                }
            }

            .el-icon-close {
                &:hover {
                    color: $red;
                }
            }
        }
        .el-drawer__body {
            padding: 0 15px 15px;
            overflow: auto;

            .drawer-panel {
                padding: 15px 15px 50px;
            }
            .btns {
                position: absolute;
                z-index: 10001;
                left: 0;
                right: 0;
                bottom: 0;
                padding: 15px;
                border-top: 1px solid $border;
                text-align: right;
                background: #fff;

            }
        }
    }
</style>
<template>
    <el-drawer class="my-drawer" :visible="show" :close-on-press-escape="false"  append-to-body :size="max ? '100%' : size" :show-close="false">
        <template #title>
            {{title}}
            <span>
                <i class="el-icon-full-screen" @click="changeFullScreen"></i>
                <i class="el-icon-close" @click="$emit('update:show', false)"></i>
            </span>
        </template>
        <slot></slot>
    </el-drawer>
</template>

<script>
    export default {
        props: {
            title: {},
            show: {
                type: Boolean,
                default: false,
            },
            size: {
                default: '40%'
            },
        },
        data() {
            return {
                max: false,
            }
        },
        methods:{
            changeFullScreen(){
                this.max = !this.max;
                this.$emit('changeFullScreen');
            }
        }
    }
</script>
